import React, { createContext, useState } from "react";
import { 
  api,
  // apiNotSensedia
 } from "../middlewares";

const ContextDestaques = createContext();

function Destaques({ children }) {
  const [allDestaques, setAllDestaques] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getAllDestaques() {
    return await api.get("/Destaque/GetAllDestaques");
    // return await apiNotSensedia.get("destaque/getalldestaques");
  }

  async function loadDestaques() {
    try {
      let result = await getAllDestaques();
      if (result.data.length > 0) {
        setAllDestaques(result);
      }
    } catch (error) {
      setAllDestaques([]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <ContextDestaques.Provider
      value={{ loadDestaques, allDestaques, loading, getAllDestaques }}
    >
      {children}
    </ContextDestaques.Provider>
  );
}

export { ContextDestaques, Destaques };
